export const DefaultMessageView = "ChatHistory_DefaultMessageView";
